import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-feed-card',
  templateUrl: './feed-card.component.html',
  styleUrls: ['./feed-card.component.scss']
})
export class FeedCardComponent implements OnInit {

  @Input() feed: any;

  constructor() {

  }

  ngOnInit() {
  }

  openLinkInBrowser() {
    window.open(this.feed.link);
  }
}


// WEBPACK FOOTER //
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/app/feed-card/feed-card.component.ts